export const SHOW_INTEREST = "Show interest";
export const SHOW_INTEREST_TITLE = `IMPORTANT: Drop a "Hello" in the Chat section after selecting "Show Interest." This Is the only way for the customer to know about your interest. This will move the event to your "Events in Progress" section`;
export const SEND_FIRST_TIME_QUOTE = "IMPORTANT: Drop a \"Hello\" in the Chat section to discuss and send a quote to the customer. This is the only way for the customer to know about your interest. This will move the event to your \"In Progress\" section";
export const SEND_QUOTE = "Send a quote"
export const ACCEPT_REQUEST = "Accept Request";
export const DECLINE_REQUEST = "Decline Request";
export const REQUEST_ACCEPT_DECLINE_TITLE =
	"Accept Request to initiate chat and start quoting.";
export const REQUEST_ACCEPT_DECLINE_TITLE_CULINARY =
	"Accept Request to initiate chat with the customer";
export const REOPEN = "Re-Open";
export const REOPEN_TITLE = "You have declined this event and closed the chat";
export const EVENT_CONCLUDED = "This Event has already concluded.";

export const DETAILS_TAB_VALUE = "details";
export const CHAT_TAB_VALUE = "chat";
export const QUOTE_TAB_VALUE = "my_quote";
export const TRANSACTION_DETAILS = "transaction_details";
export const YOUR_QUOTE = "Your Quote";
export const DECLINE_EVENT = "Decline event";
export const VENDOR_STATUS_FOR_HIDE_DECLINE_EVENT = [4, 2, 5, 6, 7, 8];

export const notficationsTabsMapping = {
	Chat: CHAT_TAB_VALUE,
	Quotes: QUOTE_TAB_VALUE,
};

export enum EventDetailTabsEnum {
	Details = DETAILS_TAB_VALUE,
	Chat = CHAT_TAB_VALUE,
	MyQuote = QUOTE_TAB_VALUE,
	TransactionDetails = TRANSACTION_DETAILS,
}